// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Spoq","questions":"styles_questions__nBMly","footer":"styles_footer__XkDeL"};